import { render, staticRenderFns } from "./RemarketProcessing.vue?vue&type=template&id=38ed0c20"
import script from "./RemarketProcessing.vue?vue&type=script&lang=js"
export * from "./RemarketProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports